module.exports = __webpack_public_path__ + "static/media/new admissions.f95dc5dc.svg";